import service from '@/utils/request'
// 获取用户信息
export function getUserInfoApi() {
  return service.post(`pcuser/userinfor`);
}
// 修改个人信息
export function editUserInfoApi(data) {
  return service.post(`pcuser/edituserinfor`, data);
}

// 密码修改
export function editUserPwdApi(data) {
  return service.post(`pcuser/editpwd`, data);
}
// 获取价格类型
export function getPriceTypeApi() {
  return service.post(`config/pricesetlist`);
}